document.addEventListener("DOMContentLoaded", () => {
  // Trigger-Produkte aus dem data-Attribut abrufen
  // const scriptTag = document.querySelector("script[data-trigger-products]");
  // if (!scriptTag) return;

  // let triggerProductsData;
  try {
    // const rawData = scriptTag.getAttribute("data-trigger-products");
    // console.log("Raw JSON Data:", rawData);

    const triggerProductsData = window.triggerProductsData;
    if (!triggerProductsData || !triggerProductsData.length) return;
  } catch (error) {
    console.error("Fehler beim Parsen der Trigger-Produkte:", error);
    console.error(
      "Raw data around position 573:",
      scriptTag.getAttribute("data-trigger-products").substring(550, 600)
    );

    // Fallback: Versuche das JSON zu reparieren
    try {
      let fixedData = scriptTag.getAttribute("data-trigger-products");
      // Repariere häufige JSON-Probleme
      fixedData = fixedData.replace(/€ d'/g, "€ d&#39;");
      fixedData = fixedData.replace(/d'achat/g, "d&#39;achat");
      fixedData = fixedData.replace(/l'eau/g, "l&#39;eau");

      console.log("Versuche repariertes JSON:", fixedData.substring(550, 600));
      triggerProductsData = JSON.parse(fixedData);

      if (!triggerProductsData || !triggerProductsData.length) return;
      console.log("✅ JSON erfolgreich repariert und geparst!");
    } catch (secondError) {
      console.error(
        "Auch das reparierte JSON konnte nicht geparst werden:",
        secondError
      );
      return;
    }
  }

  console.log("Trigger Products Data:", triggerProductsData);
  console.log(
    "Current Market:",
    window.Shopify?.locale,
    window.Shopify?.currency
  );

  // Auf Änderungen am Warenkorb hören
  document.addEventListener("cart:refresh", checkCartAndShowFreeProducts);
  document.addEventListener("cart:updated", checkCartAndShowFreeProducts);

  // Zusätzlich auf AJAX-Anfragen hören, die den Warenkorb ändern könnten
  setupCartChangeListeners();

  // Initial prüfen
  checkCartAndShowFreeProducts();

  /**
   * Richtet Listener für Warenkorb-Änderungen ein, die durch AJAX-Anfragen ausgelöst werden
   */
  function setupCartChangeListeners() {
    // Überwachen der "Add to Cart"-Buttons in den Free-Products
    document.addEventListener("click", function (event) {
      const addToCartButton = event.target.closest('button[name="add"]');
      if (addToCartButton) {
        // Kurze Verzögerung, um sicherzustellen, dass die Anfrage abgeschlossen ist
        setTimeout(checkCartAndShowFreeProducts, 500);
      }
    });

    // Überwachen der Quantity-Änderungen im Warenkorb
    document.addEventListener("change", function (event) {
      if (event.target.matches('input[name="quantity"]')) {
        setTimeout(checkCartAndShowFreeProducts, 500);
      }
    });

    // Überwachen der "Remove"-Buttons im Warenkorb
    document.addEventListener("click", function (event) {
      if (
        event.target.closest(".remove-button") ||
        event.target.closest("[data-cart-remove]")
      ) {
        setTimeout(checkCartAndShowFreeProducts, 500);
      }
    });

    // Überwachen des XMLHttpRequest-Objekts für AJAX-Anfragen
    const originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
      this.addEventListener("load", function () {
        // Prüfen, ob die Anfrage den Warenkorb betrifft
        const url = this.responseURL;
        if (
          url &&
          (url.includes("/cart/add") ||
            url.includes("/cart/update") ||
            url.includes("/cart/change") ||
            url.includes("/cart/clear"))
        ) {
          setTimeout(checkCartAndShowFreeProducts, 500);
        }
      });
      originalXHROpen.apply(this, arguments);
    };

    // Überwachen des Fetch-API für moderne AJAX-Anfragen
    const originalFetch = window.fetch;
    window.fetch = function () {
      const url = arguments[0];
      const fetchPromise = originalFetch.apply(this, arguments);

      if (
        typeof url === "string" &&
        (url.includes("/cart/add") ||
          url.includes("/cart/update") ||
          url.includes("/cart/change") ||
          url.includes("/cart/clear"))
      ) {
        fetchPromise.then(() => {
          setTimeout(checkCartAndShowFreeProducts, 500);
        });
      }

      return fetchPromise;
    };
  }

  /**
   * Prüft den Warenkorb auf Trigger-Produkte und zeigt entsprechende kostenlose Produkte an
   */
  async function checkCartAndShowFreeProducts() {
    try {
      // Warenkorb-Daten abrufen
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Fehler beim Abrufen des Warenkorbs");
      const cart = await response.json();

      // Sowohl Handles als auch IDs der Produkte im Warenkorb extrahieren
      const cartProductHandles = cart.items.map((item) => item.handle);
      const cartProductIds = cart.items.map((item) => item.product_id);

      console.log("Produkte im Warenkorb (Handles):", cartProductHandles);
      console.log("Produkte im Warenkorb (IDs):", cartProductIds);

      // Für jedes Trigger-Produkt prüfen, ob es im Warenkorb ist
      triggerProductsData.forEach((triggerData, index) => {
        console.log(`Prüfe Trigger ${index + 1}:`, {
          triggerProductId: triggerData.triggerProductId,
          triggerProductHandle: triggerData.triggerProductHandle,
          freeProductsTitle: triggerData.freeProductsTitle,
          market: triggerData.market,
          currency: triggerData.currency,
        });

        // Prüfen, ob das Trigger-Produkt im Warenkorb ist
        // KORRIGIERT: Verwende triggerProductHandle statt triggerProductId für Handle-Vergleich
        const isTriggerInCartByHandle =
          triggerData.triggerProductHandle &&
          cartProductHandles.includes(triggerData.triggerProductHandle);

        // Fallback: Auch nach der alten triggerProductId suchen (falls es ein Handle ist)
        const isTriggerInCartByOldId =
          triggerData.triggerProductId &&
          cartProductIds.includes(triggerData.triggerProductId);

        const isTriggerInCart =
          isTriggerInCartByHandle || isTriggerInCartByOldId;

        console.log(`Trigger ${index + 1} Prüfung:`, {
          byHandle: isTriggerInCartByHandle,
          byOldId: isTriggerInCartByOldId,
          result: isTriggerInCart,
        });

        // Prüfen, ob eines der Free-Products bereits im Warenkorb ist
        const isFreeProductInCart = triggerData.freeProducts.some(
          (freeProduct) => {
            const byHandle = cartProductHandles.includes(freeProduct.handle);
            const byId = cartProductIds.includes(parseInt(freeProduct.id));
            return byHandle || byId;
          }
        );

        console.log(`Free Product bereits im Warenkorb:`, isFreeProductInCart);

        // Den Container für dieses Trigger-Produkt finden
        const triggerContainers = document.querySelectorAll(
          `.trigger-products-container`
        );

        // Container anhand des Index identifizieren
        const container = triggerContainers[index];

        if (container) {
          // Nur anzeigen, wenn das Trigger-Produkt im Warenkorb ist UND das Free-Product NICHT im Warenkorb ist
          if (isTriggerInCart && !isFreeProductInCart) {
            // Trigger-Produkt ist im Warenkorb und Free-Product nicht, Container anzeigen
            container.style.display = "grid";
            console.log(
              `✅ Zeige Container für Trigger an: ${triggerData.freeProductsTitle}`
            );

            // Preise durch "Gratis"-Label ersetzen
            replacePricesWithFreeLabel(container, triggerData.freeLabel);
          } else {
            // Trigger-Produkt ist NICHT im Warenkorb oder Free-Product ist bereits im Warenkorb, Container ausblenden
            container.style.display = "none";
            if (!isTriggerInCart) {
              console.log(
                `❌ Blende Container aus: ${triggerData.freeProductsTitle} (Trigger nicht im Warenkorb)`
              );
            } else if (isFreeProductInCart) {
              console.log(
                `❌ Blende Container aus: ${triggerData.freeProductsTitle} (Free-Product bereits im Warenkorb)`
              );
            }
          }
        } else {
          console.warn(`Container für Trigger ${index + 1} nicht gefunden`);
        }
      });
    } catch (error) {
      console.error("Fehler beim Prüfen des Warenkorbs:", error);
    }
  }

  /**
   * Ersetzt die Preise in einem Container durch ein "Gratis"-Label
   * @param {HTMLElement} container - Der Container mit den Produkten
   * @param {string} freeLabel - Der Text für das "Gratis"-Label
   */
  function replacePricesWithFreeLabel(container, freeLabel) {
    // Alle Preis-Elemente im Container finden
    const priceElements = container.querySelectorAll(".price-list");

    priceElements.forEach((priceElement) => {
      // Prüfen, ob das Element bereits ein Gratis-Label hat
      if (!priceElement.querySelector(".free-label")) {
        // Originalen Inhalt speichern (falls wir ihn später wiederherstellen wollen)
        const originalHTML = priceElement.innerHTML;
        priceElement.setAttribute("data-original-price", originalHTML);

        // Neues Element für das Gratis-Label erstellen
        const freeElement = document.createElement("span");
        freeElement.classList.add("free-label");
        freeElement.textContent = freeLabel || "Gratis";

        // Stil für das Gratis-Label
        freeElement.style.color = "#4caf50";
        freeElement.style.fontWeight = "bold";

        // Preis-Element leeren und Gratis-Label einfügen
        priceElement.innerHTML = "";
        priceElement.appendChild(freeElement);
      }
    });
  }
});
